import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "page-wrapper" };
import { useStore } from "@/shared/composables/useStore";
import { computed } from "vue";
import CustomToast from "@/components/atoms/CustomToast.vue";
import RefreshToken from "@/components/atoms/RefreshToken.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        const isAuthenticated = computed(() => store.getters.isAuthentificated);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('app-container layout-wrapper' + (!isAuthenticated.value ? ' login-container' : ''))
            }, [
                (isAuthenticated.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_router_view, { name: "header" }),
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_router_view),
                            _createVNode(_component_router_view, { name: "footer" })
                        ]),
                        _createElementVNode("div", null, [
                            _createVNode(CustomToast),
                            _createVNode(RefreshToken)
                        ])
                    ], 64))
                    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
            ], 2));
        };
    }
});
